import type { FeatureFlagService, IContext } from "../types";

export class FalsyMock<T extends string> implements FeatureFlagService {
  private context: IContext = {};
  private userId: string | undefined;

  async connect(): Promise<void> {
    await Promise.resolve();
  }

  async isEnabled(_flag: T): Promise<boolean> {
    return await Promise.resolve(false);
  }

  getContext() {
    return this.context;
  }

  setContextField(field: keyof IContext, value?: string): void {
    this.context = {
      ...this.context,
      [field]: value,
    };
  }

  getUserId(): string | undefined {
    return this.userId;
  }

  identify(userId?: string): void {
    this.userId = userId;
  }
}
